import { render } from "./icon-paperclip.vue?vue&type=template&id=1b5a5fa8"
import script from "./icon-paperclip.vue?vue&type=script&lang=js"
export * from "./icon-paperclip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__